import { render, staticRenderFns } from "./selectExpertEducation.vue?vue&type=template&id=22dd7f64&scoped=true&"
import script from "./selectExpertEducation.vue?vue&type=script&lang=js&"
export * from "./selectExpertEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd7f64",
  null
  
)

export default component.exports